import { createAPIHeaders, fetchUtility } from '.';
import { ApiCustomDataRequest } from '../../types/admin';

export const updateApiCustomData = async (apiKey: string, body: ApiCustomDataRequest): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/updateApiCustomData`, {
		headers: createAPIHeaders(apiKey, 'PATCH'),
		method: 'PATCH',
		body: JSON.stringify(body),
	});
};
